import { Navigate, useLocation } from 'react-router-dom';

/** Dealer Kit was renamed CRM Integration; old bookmarks and links keep working. */
export const LegacyDealerKitRedirect = () => {
  const { pathname, search } = useLocation();
  return <Navigate to={pathname.replace(/^\/dealer-kit/, '/crm-integration') + search} replace />;
};
